import { render, staticRenderFns } from "./ProjectUsersTable.vue?vue&type=template&id=72b84b72&scoped=true&lang=pug"
import script from "./ProjectUsersTable.vue?vue&type=script&lang=js"
export * from "./ProjectUsersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b84b72",
  null
  
)

export default component.exports